import { apiRequest } from './client'
import type {
  SilkSendTipBody,
  SilkSendTipResponse,
  SilkTipList,
} from './types'

export const tipsApi = {
  /** 打赏作品(登录后) */
  send: (workId: number, body: SilkSendTipBody) =>
    apiRequest<SilkSendTipResponse>(`/api/v1/works/${workId}/tips`, {
      method: 'POST',
      body,
    }),

  /** 作品打赏列表(公开) */
  listByWork: (workId: number, params?: { limit?: number; offset?: number }) =>
    apiRequest<SilkTipList>(`/api/v1/works/${workId}/tips`, {
      query: params,
      auth: false,
    }),
}
